import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function PeepRedesignSwapperModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.PEEP_REDESIGN_SWAPPER_MODAL);

    const pages = [
        {
            id: 'peep-redesign-swapper-slide-one',
            body: <PeepRedesignSwapperSlideOne />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='onboarding/peep-redesign/peep-redesign-swapper'
                                width={401}
                            />
                        }
                        width={401}
                    />
                ),
            },
        },
    ];

    return isOpen ? (
        <OnboardingModal
            trapFocus={false}
            lastButtonText='Done'
            pages={pages}
            onClose={onClose}
            onFinish={onClose}
            canClickOutsideToClose={false}
            maxHeight={586}
        />
    ) : (
        <></>
    );
}

function PeepRedesignSwapperSlideOne() {
    return (
        <OnboardingBody title='Important reminders!'>
            <div className='mt-16'>
                <BulletedList
                    greyBullets={true}
                    bullets={[
                        <span key='1'>
                            Just a friendly reminder: you can easily toggle the preview of new
                            updates from your profile panel!
                        </span>,
                        <span key='2'>
                            Whether you’ve opted in or need a little more time, we’ll send you a
                            gentle nudge 48 hours before the release.
                        </span>,
                        <span key='3'>
                            We’d love to hear your thoughts, so feel free to share them through the
                            feedback form!
                        </span>,
                    ]}
                />
            </div>
        </OnboardingBody>
    );
}
